import baseTime, { Moment } from 'moment'
import 'moment-duration-format'

baseTime.updateLocale('en', {
 relativeTime: {
  future: 'in %s',
  past: '%s ago',
  s: 'a few seconds',
  ss: '%d seconds',
  m: 'a minute',
  mm: '%d minutes',
  h: 'an hour',
  hh: '%d hours',
  d: '1 day',
  dd: '%d days',
  w: 'a week',
  ww: '%d weeks',
  M: 'a month',
  MM: '%d months',
  y: 'a year',
  yy: '%d years',
 },
})

export default baseTime

export type TBaseTime = Moment
